import CryptoJS from 'crypto-js';

export const getEncryptedParams = data =>
  CryptoJS.AES.encrypt(data, process.env.REACT_APP_AUTH_KEY).toString();

export const navigateUrl = async user => {
  const url = process.env.REACT_APP_MALA_URL;
  if (!url) return;
  // creating user data
  // used single characters like u, t, p due to url length limitations
  const userData = {
    u: user.username,
    r: user.redirectData?.redirectPath,
  };
  if (user.isSSO) {
    userData['t'] = user.tokens.idToken.jwtToken;
  } else {
    userData['p'] = user.password;
  }

  // encrypting user data
  const data = getEncryptedParams(JSON.stringify(userData));

  // creating link
  let element = document.createElement('a');
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const uu = url + '/mala/' + btoa(data);
    element.href = uu;
  } else {
    element.href = 'http://' + url + '/mala/' + btoa(data);
  }

  

  // removing BB local storage
  localStorage.removeItem('user');
  window.location.replace('/');

  // navigating to url
  element.click();
};
